import { getCleanMacAddressPairingId } from './get-clean-mac-address-pairing-id'

/** 6 alphanumeric character pairs separated by colons. Case insensitive. Example: 01:23:45:67:89:aF */
const MODBUS_TCP_EVSE_PAIRING_ID_REGEX = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/i
/** 6 alphanumeric character pairs separated by dashes. Case insensitive. Example: 01-23-45-67-89-aF */
const MODBUS_TCP_EVSE_PAIRING_ID_WITH_MINUS_REGEX = /^([0-9A-F]{2}-){5}[0-9A-F]{2}$/i
/** 6 alphanumeric character pairs with no separator. Case insensitive. Example: 01-23-45-67-89-aF */
const MODBUS_TCP_EVSE_PAIRING_ID_NO_COLON_REGEX = /^[0-9A-F]{12}$/i

export const isValidModbusTcpPairingId = (pairingId: string): boolean => {
  return (
    MODBUS_TCP_EVSE_PAIRING_ID_REGEX.test(pairingId) ||
    MODBUS_TCP_EVSE_PAIRING_ID_NO_COLON_REGEX.test(pairingId) ||
    MODBUS_TCP_EVSE_PAIRING_ID_WITH_MINUS_REGEX.test(pairingId)
  )
}

/**
 * Given a ModbusTcp pairing id, it returns the id with colons in the right places.
 * If an invalid pairing id is given, it returns null.
 */
export const formatModbusTcpPairingId = (pairingId: string): string | null => {
  if (!isValidModbusTcpPairingId(pairingId)) return null
  const c = pairingId.replaceAll(':', '').replaceAll('-', '')

  return `${c[0]}${c[1]}:${c[2]}${c[3]}:${c[4]}${c[5]}:${c[6]}${c[7]}:${c[8]}${c[9]}:${c[10]}${c[11]}`
}

export const isModbusTcpPairingIdDuplicate = (pairingId: string, initialPairingId: string, usedCleanPairingIds: string[]): boolean => {
  if (!pairingId.trim()) return false

  const cleanPairingId = getCleanMacAddressPairingId(pairingId)
  const cleanInitialPairingId = getCleanMacAddressPairingId(initialPairingId)

  // Exclude itself
  if (cleanPairingId === cleanInitialPairingId) return false

  return usedCleanPairingIds.some(id => id === cleanPairingId)
}
